module.exports = __webpack_public_path__ + "images/avatars/male/8.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/8.png
// module id = mQW2
// module chunks = 153